const CHECKOUT_MESSAGE = 'frontend/checkout-message/CHECKOUT_MESSAGE';
const RESET_CHECKOUT_MESSAGE = 'frontend/checkout-message/RESET_CHECKOUT_MESSAGE';
const CHECKOUT_MESSAGE_DEFAULT = 'NONE';

const initialState = {
  status: CHECKOUT_MESSAGE_DEFAULT,
  message: '',
  data: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RESET_CHECKOUT_MESSAGE:
      return initialState;
    case CHECKOUT_MESSAGE:
      return action.payload;
    default:
      return state;
  }
}
